import { ReactNode } from "react"

import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import * as Styled from "./Sidebar.styled"

type SidebarProps = {
    className?: string,
    children?: ReactNode,
    shadowed?: boolean,
}

export function Sidebar(props: SidebarProps) {

    const {
        className,
        children,
        shadowed = false,
    } = props

    const isMobile = useIsMobileDevice()

    return (
        <Styled.Drawer className={className} isMobile={isMobile} variant="permanent" shadowed={shadowed}>
            {children}
        </Styled.Drawer>
    )
}
